import graphql__61ceda23c3461aeee091 from "./__generated__/SubmitVoteMutation.graphql.js";import { commitMutation } from "react-relay";
import { graphql } from "react-relay";
import appRelayEnvironment from "../config/AppRelayEnvironment";

const mutation = graphql__61ceda23c3461aeee091;

function submitVote(votable, voteType, onCompleted) {
  const variables = {
    votableId: votable.id,
    voteType: voteType
  };

  return commitMutation(appRelayEnvironment, {
    mutation,
    variables,
    onCompleted,
    onError: error => console.error(error)
  });
}

export { submitVote };
